<template>
	<v-dialog v-model="visible" max-width="325" @click:outside="close(false)">
		<template v-slot:activator="{ on, attrs }">
			<slot name="button" v-bind="{ on, attrs }" />
		</template>

		<v-card :loading="loading">
			<v-card-title class="headline" v-text="title" />
			<v-card-text v-text="body" />
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn
					v-if="showCancel"
					color="rust-red"
					text
					@click="close(false)"
					v-text="cancelButtonText"
				/>
				<v-btn
					v-if="showConfirm"
					color="ocean darken-1"
					text
					@click="close(true)"
					v-text="confirmButtonText"
				/>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import strings from "@/utils/strings";

export default {
	props: {
		title: {
			type: String,
			default: strings.dialogs.default.title,
		},

		body: {
			type: String,
			default: strings.dialogs.default.body,
		},

		confirmed: {
			type: Function,
			default: () => {},
		},

		showConfirm: {
			type: Boolean,
			default: true,
		},

		confirmButtonText: {
			type: String,
			default: "Confirm",
		},

		showCancel: {
			type: Boolean,
			default: true,
		},

		cancelButtonText: {
			type: String,
			default: "Cancel",
		},
	},

	data: function() {
		return {
			visible: false,
			loading: false,

			resolve: null,
		};
	},

	methods: {
		pop() {
			this.visible = true;
			return new Promise((resolve, reject) => {
				this.resolve = resolve;
			});
		},

		async close(confirmed) {
			if (!confirmed) {
				this.visible = false;
				if (this.resolve) this.resolve(false);
				return;
			}

			this.loading = true;
			try {
				await this.confirmed();
				if (this.resolve) this.resolve(true);
			} finally {
				this.loading = false;
				this.visible = false;
			}
		},
	},
};
</script>
